import * as React from 'react';
import { FormControl } from '@common/components/form-control';
import moment from 'moment';

import { formatDate } from '@common/utils/date';
import { LOOKUP_MODULE_NAME } from '../../LookupTable';

import './Date.styles.scss';

const getNormalizedValue = (value) => {
  if (!value) {
    return '';
  }

  return moment(value).format('YYYY-MM-DD');
};

export const Date = (props) => {
  const { value, defaultValue, className, index, id, metadata, onSave } = props;
  const normalizedValue = getNormalizedValue(value || defaultValue);
  const [savedValue, setSavedValue] = React.useState(normalizedValue);
  const [currentValue, setCurrentValue] = React.useState(normalizedValue);

  React.useEffect(() => {
    setSavedValue(normalizedValue);
    setCurrentValue(normalizedValue);
  }, [index, value, id]);

  const handleChange = React.useCallback(async (e) => {
    try {
      e.persist();

      const { value } = e.target;

      setCurrentValue(value);

      await onSave({
        index,
        id,
        value: formatDate(value, { format: 'MM/DD/YYYY' }),
        metadata,
      });

      setSavedValue(value);
    } catch (err) {
      setCurrentValue(savedValue);
    }
  }, [currentValue, index, id, savedValue, onSave]);

  return (
    <FormControl
      id={`${LOOKUP_MODULE_NAME}-date--id-${id}--index-${index}`}
      title={currentValue}
      className={className}
      type="date"
      value={currentValue}
      onChange={handleChange}
    />
  );
};

Date.defaultProps = {
  defaultValue: '',
};